import React from 'react';
import { FOOTER, SITE_CONFIG } from '@/constants/content';
import { Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-2" data-testid="footer-brand">
            <div className="mb-4">
              <img
                src="/indexone-logo.png"
                alt="INDEXONE - Procesos Digitales"
                className="h-16 w-auto"
                loading="lazy"
                data-testid="footer-logo-image"
              />
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              {FOOTER.description}
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3" data-testid="footer-email">
                <Mail className="w-5 h-5 text-orange-500" />
                <span className="text-sm">{SITE_CONFIG.email}</span>
              </div>
              <div className="flex items-center gap-3" data-testid="footer-phone">
                <Phone className="w-5 h-5 text-orange-500" />
                <span className="text-sm">{SITE_CONFIG.phone}</span>
              </div>
              <div className="flex items-center gap-3" data-testid="footer-address">
                <MapPin className="w-5 h-5 text-orange-500" />
                <span className="text-sm">{SITE_CONFIG.address}</span>
              </div>
            </div>
          </div>

          {/* Link Columns */}
          {FOOTER.columns.map((column, idx) => (
            <div key={idx} data-testid={`footer-column-${idx}`}>
              <h3
                className="text-white font-bold mb-4"
                style={{ fontFamily: 'Manrope, sans-serif' }}
                data-testid={`footer-column-title-${idx}`}
              >
                {column.title}
              </h3>
              <ul className="space-y-2">
                {column.links.map((link, linkIdx) => (
                  <li key={linkIdx}>
                    <a
                      href={link.href}
                      className="text-gray-400 transition-colors text-sm"
                      style={{ '--hover-color': '#D7A22F' }}
                      onMouseEnter={(e) => e.currentTarget.style.color = '#D7A22F'}
                      onMouseLeave={(e) => e.currentTarget.style.color = '#9CA3AF'}
                      data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-500" data-testid="footer-copyright">
              {FOOTER.copyright}
            </p>
            <div className="flex items-center gap-6">
              <a
                href="#"
                className="text-gray-500 transition-colors text-sm"
                onMouseEnter={(e) => e.currentTarget.style.color = '#D7A22F'}
                onMouseLeave={(e) => e.currentTarget.style.color = '#6B7280'}
                data-testid="footer-privacy-link"
              >
                Política de Privacidad
              </a>
              <a
                href="#"
                className="text-gray-500 transition-colors text-sm"
                onMouseEnter={(e) => e.currentTarget.style.color = '#D7A22F'}
                onMouseLeave={(e) => e.currentTarget.style.color = '#6B7280'}
                data-testid="footer-terms-link"
              >
                Términos de Servicio
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};